import script from "./FullWidthVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./FullWidthVideo.vue?vue&type=script&setup=true&lang=js"

import "./FullWidthVideo.vue?vue&type=style&index=0&id=65ca3098&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ca3098"]])

export default __exports__